import { Component, Input } from '@angular/core';
import { Loader } from '../loader.model';
import { LoaderEllipsisComponent } from '../ellipsis/ellipsis.component';

@Component({
  selector: 'infinite-loader',
  standalone: true,
  imports: [LoaderEllipsisComponent],
  templateUrl: './infinite-loader.component.html',
  styleUrl: './infinite-loader.component.scss',
})
export class InfiniteLoaderComponent {
  @Input() loader!: Loader;
}
